function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5711 10.5858l-8.1318 8.1317c-1.5627 1.5627-4.0941 1.5627-5.6568 0-1.5627-1.5627-1.5627-4.0941 0-5.6568l8.8388-8.8389c.9758-.9758 2.5597-.9758 3.5356 0 .9758.9758.9758 2.5598 0 3.5356l-7.4247 7.4246c-.3889.3889-1.0253.3889-1.4142 0-.3889-.3889-.3889-1.0253 0-1.4142l6.7175-6.7175-1.0606-1.0607-6.7175 6.7175c-.9759.9758-.9759 2.5597 0 3.5355.9758.9758 2.5597.9758 3.5355 0l7.4246-7.4246c1.5627-1.5627 1.5627-4.0941 0-5.6568-1.5627-1.5627-4.0941-1.5627-5.6568 0L4.7218 12c-2.1496 2.1496-2.1496 5.6286 0 7.7782 2.1496 2.1496 5.6286 2.1496 7.7782 0l8.1317-8.1318-1.0606-1.0606z"
});

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#037BFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.9272f98a.svg";
export { ForwardRef as ReactComponent };